import { Especificacao } from './especificacao.model';
import { PCAStatus, PCAOrdenacao } from '../enums/pca.enum';

export interface PCA {
  CODPCA: number;
  ANO: number;
  REVISAO: number;
  CADASTRO?: Date;
  DATAULTIMAATUALIZACAO: Date;
  VALORESTIMADOTOTAL: number;
  QUANTIDADEITENSDISTINTOS: number;
  STATUS: PCAStatus;
  ITENS?: PCAItem[];
}

// Item do PCA vinculado a uma especificação de compra
export interface PCAItem {
  CODESPECIFICACAOCOMPRAPCA: number;
  CODPCA: number;
  CODESPECIFICACAO?: number;
  ANOSOLICITACAO?: number;
  DEMANDACONSOLIDADA?: number;
  PENDENCIASELECAO?: string;
  CODESPECIFICACAOCOMPRA: number;
  QUANTIDADETOTAL: number;
  VALORMEDIOUNITARIO: number;
  VALORTOTALESTIMADO: number;
  PRIORIDADEMEDIA: {
    CODPRIORIDADE: number;
    SCORE: number;
  };
  ESPECIFICACAO: Especificacao;
  SOLICITACOESCOMPRA: SolicitacaoOrigem[];
}

// Item consolidado agrupando solicitações de compra por especificação
// Inclui dados do PCA se o item já estiver adicionado
export interface PCAItemConsolidado {
  ESPECIFICACAO: Especificacao;
  QUANTIDADETOTAL: number;
  VALORMEDIOUNITARIO: number;
  VALORTOTALESTIMADO: number;
  PRIORIDADEMEDIA: {
    CODPRIORIDADE: number;
    SCORE: number;
  };
  UNIDADESSOLICITANTES: number;
  TOTALSOLICITACOES: number;
  SOLICITACOESORIGEM: SolicitacaoOrigem[];
  // Campos do PCA (preenchidos se o item já estiver adicionado)
  CODESPECIFICACAOCOMPRAPCA: number | null;
  QUANTIDADEPCA: number | null;
  VALORPCA?: number | null;
  CODESPECIFICACAOCOMPRAORIGINAL?: number | null;
  PRIORIDADEPCA: { CODPRIORIDADE: number; SCORE: number } | null;
  ADICIONADOPCA: boolean;
}

// Dados de origem de uma solicitação dentro do item consolidado
export interface SolicitacaoOrigem {
  CODUNIDADE?: number;
  ANOSOLICITACAO?: number;
  CODSOLICITACAO: number;
  CODCATEGORIASOLICITACAO: number;
  CODESPECIFICACAOCOMPRA: number;
  NUMEROSOLICITACAO: string;
  SOLICITANTE: string;
  UNIDADE: string;
  QUANTIDADE: number;
  VALOR: number;
  PRIORIDADE: number;
}

// Dados simplificados da solicitação de compra
export interface SolicitacaoCompra {
  CODSOLICITACAOCOMPRA: number;
  CODSOLICITACAO: number;
  CODUNIDADE: number;
}

export interface PCAFiltros {
  ano?: number;
  ordenacao?: PCAOrdenacao;
  status?: PCAStatus;
}

export interface PCACreate {
  ANO: number;
}

export interface PCAUpdate {
  CODPCA: number;
  REVISAO: number;
  ANO?: number;
}

export const PCA_RASCUNHOS_STORAGE_KEY = 'rascunhos-itens-pca:v1';

export interface PCARascunho {
  versao: 1 | 2;
  revisaoBase?: number;
  adicionadas: PCAItem[];
  editadas: { CODESPECIFICACAOCOMPRAPCA: number; QUANTIDADETOTAL: number }[];
  removidas: number[];
}

export interface PCAItemUpdate {
  CODESPECIFICACAOCOMPRAPCA?: number;
  CODESPECIFICACAOCOMPRA: number;
  CODESPECIFICACAO: number;
  ANOSOLICITACAO?: number;
  QTD: number;
}
